export type LandingType = 'website' | 'website-vet' | 'website-medic';

type UTMParams = {
	baseUrl: string;
	section: 'hero' | 'pricing' | 'contacto' | string;
	medium: string;
	landingType: LandingType;
	content: string;
	term?: string;
};

export const buildUTMUrl = ({ baseUrl, section, medium, landingType, content, term }: UTMParams): string => {
	const url = new URL(baseUrl);

	url.searchParams.set('utm_source', `landing-${section}`);
	url.searchParams.set('utm_medium', medium);
	url.searchParams.set('utm_campaign', landingType);
	url.searchParams.set('utm_content', content);
	if (term) url.searchParams.set('utm_term', term);

	return url.toString();
};
